import './hero-banner.scss';

export default {
  name: 'HeroBanner',
  props: {
    children: {
      default() {
        return [];
      },
      type: Array,
    },
    customProps: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  computed: {
    hasImageSource() {
      return (
        (this.customProps.fallback || '').length > 0
        || (this.customProps.imageSources || []).length > 0
      );
    },
  },
};
